"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarkSmallIcon = void 0;
const React = __importStar(require("react"));
const BookmarkSmallIcon = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 9, height: 13, fill: "none" }, props),
    React.createElement("path", { stroke: "#E84E1B", strokeWidth: 1.2, d: "M.832.837.837.831C.985.658 1.129.6 1.287.6h6.425c.16 0 .303.058.451.23.154.181.237.393.237.665v10.697c0 .097-.044.158-.086.186a.116.116 0 0 1-.054.022c-.007 0-.015 0-.024-.002l-3.387-2.42-.349-.25-.349.25-3.386 2.42a.087.087 0 0 1-.028.002.112.112 0 0 1-.053-.021c-.04-.027-.084-.087-.084-.187V1.495c0-.279.08-.485.232-.658Z" })));
exports.BookmarkSmallIcon = BookmarkSmallIcon;
